// src/pages/procurement/components/QuantityStepper.jsx
// Whole-number quantity input with −/+ buttons, shared by procurement item tables (PO, GRN, RTV).
// onChange receives the digits typed (string, may be '') or the stepped number; callers clamp/validate.
import React from 'react';
import { Minus, Plus } from 'lucide-react';
import styles from './QuantityStepper.module.css';

const BLOCKED_KEYS = ['.', ',', '-', 'e', 'E', '+'];

const QuantityStepper = ({ value, onChange, min = 0, max, disabled = false, hasError = false }) => {
  const current = parseInt(value, 10) || 0;
  const hasMax = max !== undefined && max !== null;

  return (
    <div className={`${styles.quantityWrapper} ${hasError ? styles.inputError : ''} ${disabled ? styles.disabled : ''}`}>
      <button
        type="button"
        onClick={() => onChange(Math.max(min, current - 1))}
        className={styles.quantityButton}
        disabled={disabled || current <= min}
      >
        <Minus size={14} />
      </button>
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ''))}
        onKeyDown={(e) => {
          if (BLOCKED_KEYS.includes(e.key)) e.preventDefault();
        }}
        min={min}
        max={hasMax ? max : undefined}
        step="1"
        className={styles.quantityInput}
        disabled={disabled}
      />
      <button
        type="button"
        onClick={() => onChange(hasMax ? Math.min(max, current + 1) : current + 1)}
        className={styles.quantityButton}
        disabled={disabled || (hasMax && current >= max)}
      >
        <Plus size={14} />
      </button>
    </div>
  );
};

export default QuantityStepper;
